import SingletonMessageBox from './SingletonMessageBox';

export default SingletonMessageBox;
